import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

const cyPrefix = 'whats-next-page';

const ids = addCyPrefixToIDs(cyPrefix, {
  BTN_OPEN_PAYOUTS_FLOW: 'BTN_OPEN_PAYOUTS_FLOW',
  BTN_OPEN_APPLICATION_CONFIRMATION: 'BTN_OPEN_APPLICATION_CONFIRMATION',
  BTN_ADD_ADDITIONAL_PRODUCTS: 'BTN_ADD_ADDITIONAL_PRODUCTS',
});

/**
 * We are exporting the IDS this way to help IDEs' code completion
 */
export const CY_WHATS_NEXT_PAGE_IDS = ids;

export const SINGLE_STEP_UNDERWRITING_US_RELEASE_DATE = '2019-12-17T13:00:00.000Z';
export const SINGLE_STEP_UNDERWRITING_EU_RELEASE_DATE = '2020-01-22T13:00:00.000Z';

export const tPrefix = 'products-fe.pages.whats_next_page';
